/*
 * Module for interacting with API endpoints relating to the Citizen management feature
 */
import { apiGet } from "@/core/api";
export const apiCitizenClassifiers = {
    getForCitizen: (citizenId) => apiGet(`citizens/${citizenId}/classifiers`),
};
